import {EntityService} from '../../../service/EntityService';

export const BUSINESS_LOCATION_TYPE = {
  HOUSEHOLD_OR_BRANCH: 1,
  PETROL_BUSINESS: 2,
} as const;

export type BusinessLocationType = typeof BUSINESS_LOCATION_TYPE[keyof typeof BUSINESS_LOCATION_TYPE];

/** Payload GET .../business-location/register-invoice/:id (địa điểm kinh doanh) */
export interface RegisterInvoiceBusinessLocation {
  id?: string;
  businessType?: BusinessLocationType | null;
  code?: string | null;
  name?: string | null;
  address?: string | null;
  active?: boolean;
  creationTime?: string;
  creatorId?: string;
  lastModificationTime?: string;
  lastModifierId?: string;
}

export class BusinessLocationService extends EntityService {

  static entity = 'app/business-location';

  static getBusinessLocation(registerInvoiceId: string): Promise<RegisterInvoiceBusinessLocation> {
    return this.axios
      .get(`${this.entity}/register-invoice/${registerInvoiceId}`)
      .then(res => res.data);
  }

}
